export default "__VITE_ASSET__EeBJs8h0__"